<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<ProblemCaseSearchDialog
					:query="q"
					:categories="categories"
					:case_types="case_types"
					@search-problem-cases="searchProblemCases($event)"
					text
				/>
				<v-btn
					v-if="authority_flag"
					color="white"
					text
					class="ml-2"
					@click="$router.push({ name: 'problem_case_new' })"
				>
					<v-icon class="mr-1">mdi-plus</v-icon>
					新規作成
				</v-btn>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters justify="end">
					<ProblemCaseSearchDialog
						:query="q"
						:categories="categories"
						:case_types="case_types"
						@search-problem-cases="searchProblemCases($event)"
					/>
					<v-btn
						v-if="authority_flag"
						color="secondary"
						class="ml-2"
						@click="$router.push({ name: 'problem_case_new' })"
					>
						<v-icon class="mr-1">mdi-plus</v-icon>
						新規作成
					</v-btn>
				</v-row>
			</template>

			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="problem_cases"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="$router.push({ name: 'problem_case_show', params: { id: item.id } })">
							<td >
								{{ item.case_number }}
							</td>
							<td>
								{{ item.name }}
							</td>
							<td>
								{{ item.case_type_i18n }}
							</td>
							<td>
								{{ item.product_category ? item.product_category.name : "" }}
							</td>
							<td>
								{{ item.product_sub_category ? item.product_sub_category.name : "" }}
							</td>
							<td>
								<template v-if="item.product">
									<p>品番:{{ item.product.product_code }}</p>
									<p>品名:{{ item.product.name }}</p>
								</template>
							</td>
							<td>
								{{ item.user.full_name }}
							</td>
							<td>
								{{ common.formatDateTime(item.created_at) }}
							</td>
							<td>
								{{ common.formatDateTime(item.updated_at) }}
							</td>
							<td>
								<a
									v-for="file in files(item)"
									@click.stop="openInNewTab(file.url)"
									:key="file.id"
									class="d-block"
									:href="file.url"
									target="_blank"
								>
									{{ file.name }}
								</a>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import ProblemCaseSearchDialog from "./components/ProblemCaseSearchDialog.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		ProblemCaseSearchDialog,
	},
	data() {
		return {
			title: "問題事例一覧",
			problem_cases: [],
			categories: [],
			case_types: [],
			authority_flag: false,
			headers: [
				{
					text: "事例番号",
					value: "case_number",
					width: "120px",
				},
				{
					text: "事例名",
					value: "name",
					width: "200px",
				},
				{
					text: "対象タイプ",
					value: "case_type_i18n",
					width: "120px",
				},
				{
					text: "対象分類",
					value: "product_category.name",
					width: "150px",
				},
				{
					text: "対象小分類",
					value: "product_sub_category.name",
					width: "180px",
				},
				{
					text: "対象製品",
					value: "product.name",
					width: "250px",
				},
				{
					text: "作成者",
					value: "user.full_name",
					width: "150px",
				},
				{
					text: "作成日",
					value: "created_at",
					width: "150px",
				},
				{
					text: "最終更新日",
					value: "updated_at",
					width: "150px",
				},
				{
					text: "添付ファイル",
					value: "attached_files",
					width: "400px",
				},
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "updated_at desc",
				case_number_cont: null,
				name_cont: null,
				case_type_eq: null,
				product_product_code_cont: null,
				product_name_cont: null,
				product_category_id_eq: null,
				product_sub_category_id_eq: null,
				created_at_gteq: null,
				created_at_lteq: null,
			},
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		this.fetchProblemCases(this.q, page, true)
	},
	methods: {
		fetchProblemCases(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/problem_cases", {
					params,
					headers,
				})
				.then((response) => {
					this.problem_cases = response.data.problem_cases
					this.pagination = response.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.categories = response.data.categories
						this.case_types = response.data.case_types
						this.authority_flag = response.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchProblemCases(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchProblemCases(q) {
			this.q = q
			this.fetchProblemCases(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		openInNewTab(url) {
			event.preventDefault()
			window.open(url, "_blank")
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		files(problem_case) {
			if (!problem_case.attached_files) {
				return []
			}
			return problem_case.attached_files.filter((file) => file.destroy_flag == false)
		},
	},
}
</script>
